export default function() {
    return {
        editItem: {
            agora_id: null,
            agreed_tnc: null,
            birthday_mode: null,
            birthyear_mode: null,
            city: "",
            coach_bio: "",
            coach_power: "",
            company: "",
            country: "",
            cover_image: "",
            created_at: "",
            degree: null,
            dob: "",
            birth_date: "",
            birth_month: "",
            birth_year: "",
            dream_job: "",
            email: "",
            email_mode: true,
            email_verification_app_type: "",
            email_verification_send_time: "",
            f_name: "",
            favourite_book: "null",
            favourite_food: "null",
            graduation_year: "null",
            interests: [],
            isFollow: false,
            is_email_verified: null,
            job_title: "",
            job_type: null,
            jobseeking: null,
            l_name: "",
            mob_no: "",
            mobno_mode: null,
            no_followers: null,
            no_following: null,
            notification_status: "",
            notification_token: null,
            preferences: {},
            profile_image: "",
            role_ids: [],
            roles: [],
            send_mail_verification: 1,
            state: "",
            status: "",
            std_code: "",
            student_type: null,
            super_power: null,
            timezone: "",
            token: "",
            univ_dept: null,
            university: "",
            updated: null,
            updated_at: "",
            username: null,
            work_phone: null,
            zip: null,
            company_role_id: null,
            department_id: null,
        },
        interest: {
            name: "",
        },
        interests: [],
        uploadImageModal: false,
    }
}